import {userPoolId,userPoolWebClientId} from '../Environments/environment'

var AmazonCognitoIdentity = require('amazon-cognito-identity-js');

var poolData = {
  UserPoolId: userPoolId,
  ClientId: userPoolWebClientId
};
var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

function asyncAuthenticateUser(cognitoUser, cognitoAuthenticationDetails) {
  return new Promise(function (resolve, reject) {
    cognitoUser.authenticateUser(cognitoAuthenticationDetails, {
      onSuccess: resolve,
      onFailure: reject,
      newPasswordRequired: resolve
    })
  })
}

function asyncForgotPassword(cognitoUser) {
  return new Promise(function (resolve, reject) {
    cognitoUser.forgotPassword({
      onSuccess: resolve,
      onFailure: reject,
      newPasswordRequired: resolve
    })
  })
}

function asyncConfirmPassword(cognitoUser, code, password) {
  return new Promise(function (resolve, reject) {
    cognitoUser.confirmPassword(code, password, {
      onSuccess: resolve,
      onFailure: reject,
    })
  })
}

function asyncGetSession(cognitoUser) {
  return new Promise(function (resolve, reject) {
    cognitoUser.getSession((err, session) => {
      if (err)
        reject(err)
      else resolve(session)
    })
  })
}

function asyncGetAttributes(cognitoUser) {
  return new Promise(function (resolve, reject) {
    cognitoUser.getUserAttributes((err, attributes) => {
      if (err)
        reject(err)
      else {
        attributes = attributes.reduce((total, curr) => {
          total[curr.Name] = curr.Value
          return total
        }, {})
        resolve(attributes)
      }
    })
  })
}

class AuthService {
  constructor() {
  }


  fetchLogin = async (email, password) => {
    var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
      {
        Username: email,
        Password: password,
      });

    var cognitoUser = new AmazonCognitoIdentity.CognitoUser({
      Username: email,
      Pool: userPool,
    });
    const user = await asyncAuthenticateUser(cognitoUser, authenticationDetails)
    return user
  };

  fetchForgotPassword = async(email) => {
    var cognitoUser = new AmazonCognitoIdentity.CognitoUser({
      Username: email,
      Pool: userPool,
    });
    await asyncForgotPassword(cognitoUser)
  }

  fetchConfirmPassword = async(email, code, password) => {
    var cognitoUser = new AmazonCognitoIdentity.CognitoUser({
      Username: email,
      Pool: userPool,
    });
    await asyncConfirmPassword(cognitoUser, code, password)
  }

  fetchAuthenticated = async () => {
    try {
      let cognitoUser = userPool.getCurrentUser()
      let session = await asyncGetSession(cognitoUser)
      return session.idToken.payload
    }
    catch (err) {
      console.log(err)
      return null
    }
  };

  fetchCurrentUser = async () => {
    try {
      let cognitoUser = userPool.getCurrentUser()
      return cognitoUser
    }
    catch (err) {
      console.log(err)
      return null
    }
  };
   machineBatchQuery = async (data) => {
    // try {
    //   let token = await AuthService.getToken()
  
    //   let results = await fetch(`${config.functionsApi}/productBatchQuery`, {
    //     method: 'post',
    //     headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
    //     body: JSON.stringify(data)
    //   })
    //   results = await results.json()
    //   console.log(results)
    //   let results = {}
    //   for (let machineId of query.machineIds) {
    //     let ref = moduleGetDB(module, {
    //       machine: machineId,
    //       productionLineId: query.productionLineId
    //     })
    //     if (conditions) {
    //       conditions.map(condition => {
    //         if (condition.length < 3) {
    //           return console.error('Incorrect condition provided for firestore');
    //         }
    //         ref = ref.where(condition[0], condition[1], condition[2]);
    //       });
    //     }
    //     let snapshot = await ref.limit(1).get()
    //     let singleDocument = null;
    //     snapshot.forEach(doc => {
    //       if (doc.exists) {
    //         singleDocument = doc.data();
    //         singleDocument.id = doc.id
    //       }
    //     });
    //     results[machineId] = singleDocument
    //   }
    //   return results
    // } catch (err) {
    //   errorHandler({
    //     status: err.code,
    //     statusText: err.message,
    //     statusRaw: err,
    //   });
    //   return false;
    // }
  };

  fetchLogout = () => {
    return userPool.getCurrentUser().signOut()
  };
  getToken = async () => {
    let cognitoUser = userPool.getCurrentUser()
    let session = await asyncGetSession(cognitoUser) 
    return session.idToken.jwtToken
  };
}
let service = new AuthService()
export default service;